import { DynamicQuestion, SurveySection } from "./types";

// Standard Lists used across the app (can be referenced or copied into options)
export const HOUSE_OWNERSHIP = ['സ്വന്തം', 'കോളനി', 'സ്വപാധിക ഉടമസ്ഥത', 'വാടക', 'പുറമ്പോക്'];
export const HOUSE_CONDITION = ['ഓട്', 'ഭാഗിക ടെറസ്', 'ഒറ്റനില ടെറസ്', 'ഇരുനില മാളിക', 'ബംഗ്ലാവ്'];
export const HOUSE_FACILITIES = ['വൈദ്യുതി', 'ഗ്യാസ്', 'കിണർ', 'പൊതുടാപ്പ്', 'വാട്ടർ സപ്ലൈ', 'പൊതു കിണർ'];
export const VEHICLES = ['സൈക്കിൾ', 'ടു വീലർ', 'ത്രീ വീലർ', 'കാർ', 'മറ്റുള്ളവ'];
export const ASSETS = ['ഭൂസ്വത്ത്', 'കൃഷി നിലം', 'വാടക കെട്ടിടം'];
export const AGRICULTURE = ['തെങ്ങ്', 'കവുങ്ങ്', 'റബ്ബർ', 'നെൽകൃഷി', 'പച്ചക്കറി', 'പുഷ്പം'];
export const HEALTH_CONDITIONS = [
  'സംതൃപ്തം', 'പ്രമേഹം', 'പ്രഷർ', 'ഹൃദ്രോഗം', 'ക്ഷയം', 'വാതം', 'ആസ്തമ', 'ക്യാൻസർ',
  'തിമിരം', 'കിഡ്‌നി രോഗം', 'ത്വക് രോഗം', 'ദന്ത രോഗങ്ങൾ', 'ഉദര രോഗങ്ങൾ',
  'മാനസികം', 'അംഗവൈകല്യം', 'അന്ധത / ബധിരത / മൂകത', 'മറ്റേതെങ്കിലും'
];
export const SOCIAL_WORK_OPTIONS = [
  'രാഷ്‌ടീയം', 'മത സംഘടന', 'സർവീസ് സംഘടന', 'സന്നദ്ധ പ്രവർത്തനം',
  'മഹല്ല് പ്രവർത്തനം', 'മറ്റേതെങ്കിലും', 'പ്രവാസി സംഘടന'
];

export const INITIAL_SECTIONS: SurveySection[] = [
  { id: 'section_1782312326957', label: 'Section B: Student Info', order: 0, isRepeater: true },
  { id: 'section_1782311875584', label: 'Section A: Parent / Guardian Info', order: 1, isRepeater: false }
];

// These questions will be loaded into storage if empty
export const INITIAL_QUESTIONS: DynamicQuestion[] = [
  // --- Section A: Parent / Guardian Info ---
  {
    id: "1782311895371",
    label: "Father's Name ",
    type: "text",
    section: "section_1782311875584",
    required: true
  },
  {
    id: "1782311944131",
    label: "Father's Phone Number",
    type: "number",
    section: "section_1782311875584",
    required: true
  },
  {
    id: "1782311923394",
    label: "Mother's Name",
    type: "text",
    section: "section_1782311875584",
    required: true
  },
  {
    id: "1782311987788",
    label: "Mother's Phone Number",
    type: "number",
    section: "section_1782311875584",
    required: true
  },
  {
    id: "1782312038535",
    label: "Parent WhatsApp Number ",
    type: "number",
    section: "section_1782311875584",
    required: true
  },
  {
    id: "1782312154158",
    label: "Parents Email ID",
    type: "text",
    section: "section_1782311875584",
    required: true
  },
  {
    id: "1782312069160",
    label: "Does the parent have a Malayalee Samajam membership number?",
    type: "yesno",
    section: "section_1782311875584",
    required: true
  },
  {
    id: "1782312123373",
    label: "Parents Samajam Membership ID Number",
    type: "number",
    section: "section_1782311875584",
    required: true,
    dependsOn: "1782312069160",
    visibleIf: true
  },

  // --- Section B: Student Info ---
  {
    id: "1782312349252",
    label: "Student Name",
    type: "text",
    section: "section_1782312326957",
    required: true
  },
  {
    id: "1782312366818",
    label: "Date of Birth",
    type: "date",
    section: "section_1782312326957",
    required: true
  },
  {
    id: "1782312394122",
    label: "Gender ",
    type: "dropdown",
    section: "section_1782312326957",
    options: ["Male", "Female"],
    required: true
  },
  {
    id: "1782312413731",
    label: "School Name",
    type: "text",
    section: "section_1782312326957",
    required: true
  },
  {
    id: "1782312452434",
    label: "Class",
    type: "dropdown",
    section: "section_1782312326957",
    options: ["KG-1", "KG-2", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "Above"],
    required: true
  },
  {
    id: "1782312825240",
    label: "Student Photo",
    type: "image",
    section: "section_1782312326957",
    required: true
  }
];